export const formatSummaryNumber = (
  value: string | number | null | undefined,
  fractionDigits = 2,
): string => {
  if (value === null || value === undefined || value === '' || value === 'N/A') return 'N/A';

  const numericValue = typeof value === 'number' ? value : Number(value.trim());
  return Number.isFinite(numericValue) ? numericValue.toFixed(fractionDigits) : String(value);
};
